import { eitaInstance as instance } from '@/api/instances'

const getExternalAuthenticationLink = async (store, { email, redirectUrl }) => {
  const queryParam = redirectUrl ? `?redirect=${redirectUrl}` : ''

  try {
    return await instance.post('external_authentication', {
      json: {
        email,
        url: `${process.env.VUE_APP_EITA_URL}/login${queryParam}`
      }
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'eita/getExternalAuthenticationLink' },
      { root: true }
    )

    return {}
  }
}

export default {
  getExternalAuthenticationLink
}
